const {
    modalPresenter
} = require('gui');

module.exports = function mapPresenter(location) {
    const mapModalPresenter = modalPresenter();
    const view = require('./mapPresenter.tpl.html');
    const c = {};

    c.show = function(region) {
        const modalRegion = mapModalPresenter.contentRegion();
        view.activate(modalRegion);
        view.frame.src = `https://www.google.com/maps/embed/v1/place?key=AIzaSyBDgCxAbkvZw21XSzvhHcBCP20D0D0KEfU&q=${location.latitude},${location.longitude}`;

        mapModalPresenter.show();
        mapModalPresenter.subscribeClose(onClose);
    };

    function onClose() {
        mapModalPresenter.unsubscribeClose(onClose);
        view.deactivate();
        mapModalPresenter.hide();
    };

    return c;
};
